import React, { useContext } from 'react';
import { useRouterState } from 'app/hooks/useRouterState';

import { OverlayContextDispatch } from 'app/containers/contexts/overlay.context';
import { parseCategories, parseDishes } from 'app/utils/basketSchema';


const IntervalDialogContent = () => (
    <>
        Произошла ошибка: в&nbsp;корзине нет&nbsp;блюд
    </>
);

/**
 * @description Диалог для обработки ошибки при создании инвойса, которая возникает, когда корзина пуста
 */
export const useEmptyBasketErrorDialog = () => {
    const { pushDialogOverlay, closeLastOverlays } = useContext(OverlayContextDispatch);

    const [routerState] = useRouterState();
    const { history } = routerState;

    const pushBasketErrorDialog = () => {
        const { location: { search } } = window;
        const categories = parseCategories(window.location);
        const dishes = parseDishes(window.location);
        const hasBasketSchema = Boolean(categories || dishes);

        const dialogData = {
            notifyOnly: true,
            strongText: <IntervalDialogContent />,
            confirmText: hasBasketSchema ? 'Обновить' : 'Выбрать блюда',
            onConfirm: () => {
                if (hasBasketSchema) {
                    window.location.reload();
                } else {
                    history.push({
                        pathname: '/menu/',
                        search,
                    });
                    closeLastOverlays();
                }
            },
        };

        pushDialogOverlay('useBasketErrorDialog', dialogData);
    };
    return pushBasketErrorDialog;
};
